module.exports = __webpack_public_path__ + "img/img-roadmap.3bf04a01.webp";